import { __toESM as e } from "../_virtual/_rolldown/runtime.js";
import { require_intermoji as t } from "../bundled_deps/.pnpm/@intercom_intermoji@2.0.3/bundled_deps/@intercom/intermoji/lib/intermoji.js";
//#region src/utils/emoji.ts
var n = /* @__PURE__ */ e(t(), 1), r = /* @__PURE__ */ function(e) {
	return e[e.None = -1] = "None", e[e.Light = 127995] = "Light", e[e.MediumLight = 127996] = "MediumLight", e[e.Medium = 127997] = "Medium", e[e.MediumDark = 127998] = "MediumDark", e[e.Dark = 127999] = "Dark", e;
}({}), i = n.default;
function a(e) {
	return i.splitOnUnicodeEmojis(e).reduce(function(e, t) {
		return e + (i.isSupportedUnicode(t) ? l(i.identifierFromUnicode(t)) : t);
	}, "");
}
function o(e) {
	return i.substituteUnicodeForColonified(e);
}
var s;
function c() {
	return s ??= i.hasNativeSupport(document), s;
}
function l(e) {
	return `:${e}:`;
}
function u() {
	s = !1;
}
function d() {
	s = !0;
}
//#endregion
export { r as SkinToneModifiers, u as disableNativeEmojiSupport, d as enableNativeEmojiSupport, c as hasNativeEmojiSupport, a as substituteColonifiedForUnicode, o as substituteUnicodeForColonified };
